<template>
    <section>
        <perfect-scrollbar>
            <table>
                <thead>
                    <tr>
                        <th class="action-column"></th>
                        <th>เลขที่</th>
                        <th>ผู้นำรถเข้าบริการ</th>
                        <th>ราคา</th>
                        <th class="text-center">สถานะ</th>
                        <th>วันที่เปิดงาน</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in resultList" :key="index">
                        <td><div class="text-center"><router-link :to="item.link" class="btn btn-sm btn-blue text-nowrap">ดูใบงาน</router-link></div></td>
                        <td>{{ item.number }}</td>
                        <td>
                            <span><b-icon icon="person" class="icon"></b-icon> {{ item.customer }}</span>
                        </td>
                        <td>{{ item.price }}</td>
                        <td class="text-center"><div class="status" :class="item.status.style">{{ item.status.text }}</div></td>
                        <td class="date-time"><b-icon icon="clock"></b-icon> {{ item.openDate }}</td>
                    </tr>
                </tbody>
            </table>
        </perfect-scrollbar>

        <div class="no-data" v-if="resultList.length === 0">
            <b-icon icon="exclamation-diamond"></b-icon>
            <span>ไม่มีประวัติรายการใบงาน</span>
        </div>

        <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="resultList.length" class="mt-4"></paging>
    </section>
</template>

<script>
import Helper from '@/resources/Helper';
import MixinJobTable from '@/components/job/JobTable';

export default {
    mixins: [ MixinJobTable ],
    data() {
        return {
            activePage: 1,
            pageSize: 20,
            resultList: []
        }
    },
    props: {
        jobList: Array
    },
    mounted() {
        this.renderJobList();
    },
    methods: {
        renderJobList() {
            this.resultList = this.mapViewData(this.jobList.filter(x => x.jobType === this.$Constants.JOB_FORM_WALKIN
                                                        || x.jobType === this.$Constants.JOB_FORM_ONLINE
                                                        || x.jobType === this.$Constants.JOB_FORM_FLEET
                                                        || x.jobType === this.$Constants.JOB_FORM_STORE));
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    number: item.number,
                    link: '/job/' + this.mixinsJobTable_GetPathName(item.jobType) + '?o=' + item.number,
                    customer: [ item.customer.customerFirstName, item.customer.customerLastName ].join(' '),
                    orderType: this.mixinsJobTable_GetOrderType(item.jobType),
                    price: Helper.getCommaNumber(this.$AppUtility.calculateOrderTotalPrice(item.order)),
                    status: this.mixinsJobTable_GetStatusDisplay(item.status),
                    openDate: this.$AppUtility.displayTimeFormat(item.openDate),
                });
            });

            return data;
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/job/JobList.scss';
</style>